import React, { useState, useEffect } from 'react';
import TestComponent from './TestComponent';
import CoverageComponent from './sysdevops/CoverageComponent';
import QualityComponent from './sysdevops/QualityComponent';
import SecurityComponent from './sysdevops/SecurityComponent';
import SystemComponent from './sysdevops/SystemComponent';
import DeploymentsComponent from './sysdevops/DeploymentsComponent';
import SecretsComponent from './sysdevops/SecretsComponent';
import DatabaseComponent from './sysdevops/DatabaseComponent';
import SonarQubeComponent from './sysdevops/SonarQubeComponent';
import ErrorState from './ui/ErrorState';

interface SysDevOpsSectionProps {
  activeTab: string;
  /**
   * Retained so the section can send the reader to a sibling view from inside
   * a panel; the section no longer renders navigation of its own.
   */
  setActiveTab?: (tab: string) => void;
}

const SysDevOpsSection: React.FC<SysDevOpsSectionProps> = ({ activeTab }) => {
  const [error, setError] = useState<string | null>(null);

  // Sys & Dev Ops has no overview view. It used to advertise an OVERVIEW tab
  // and silently swap it for Builds; the navigation now lands on Builds
  // directly, and this only guards stale links.
  const currentTab = activeTab === 'overview' ? 'builds' : activeTab;

  useEffect(() => {
    const handleError = (error: ErrorEvent) => {
      console.error('SysDevOpsSection error:', error);
      setError(error.message);
    };

    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);

  if (error) {
    return (
      <ErrorState
        title="This section hit a runtime error"
        detail={error}
        onRetry={() => setError(null)}
      />
    );
  }

  const renderComponent = () => {
    try {
      if (currentTab === 'builds') {
        return <TestComponent />;
      }

      switch (currentTab) {
        case 'coverage':
          return <CoverageComponent />;
        case 'quality':
          return <QualityComponent />;
        case 'sonarqube':
          return <SonarQubeComponent />;
        case 'security':
          return <SecurityComponent />;
        case 'system':
          return <SystemComponent />;
        case 'deployments':
          return <DeploymentsComponent />;
        case 'secrets':
          return <SecretsComponent />;
        case 'database':
          return <DatabaseComponent />;
        default:
          return <TestComponent />;
      }
    } catch (err) {
      console.error('Error rendering component:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
      return null;
    }
  };

  return (
    <div className="space-y-6">
      {renderComponent()}
    </div>
  );
};

export default SysDevOpsSection;
